var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6487V14.0973C0 14.3228 0.177198 14.5 0.402722 14.5H2.85127C2.95598 14.5 3.06069 14.4597 3.13318 14.3792L11.9286 5.59179L8.90821 2.57138L0.120817 11.3588C0.0402723 11.4393 0 11.536 0 11.6487ZM14.2644 3.25601C14.5785 2.94188 14.5785 2.43445 14.2644 2.12033L12.3797 0.235592C12.0655 -0.0785308 11.5581 -0.0785308 11.244 0.235592L9.77003 1.70955L12.7904 4.72997L14.2644 3.25601Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedEditIcon);
export default __webpack_public_path__ + "static/media/DeprecatedEditIcon.8088f7fa3b57e59cb2a6b2c92465cd2d.svg";
export { ForwardRef as ReactComponent };